<template>
  <div class="change-password-dialog">
    <el-dialog append-to-body title="权限设置" :visible="isShowPower" :close-on-click-modal="false" @close="closeDialog" width="400px">
      <div v-loading="loading">
        <el-tabs v-model="activeName">
          <el-tab-pane label="菜单权限" name="menus">
            <!--            <el-checkbox v-model="checkAllMenus" style="margin-left: 24px;">全选</el-checkbox>-->
            <!-- eslint-disable-next-line vue/max-attributes-per-line -->
            <el-tree
              ref="menuTree"
              :data="menusLists"
              show-checkbox
              node-key="id"
              :default-checked-keys="defaultChecked"
              :props="{
                label: 'title',
                isLeaf: () => {
                  return true;
                },
              }"
            ></el-tree>
          </el-tab-pane>
          <el-tab-pane label="节点权限" name="nodes">
            <el-tree ref="nodeTree" :data="nodeLists" show-checkbox node-key="id" :default-checked-keys="defaultChecked" :props="{ label: 'title' }"></el-tree>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" :disabled="loading" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['isShowPower', 'row'],

  data() {
    return {
      doSubmitLoading: false,
      activeName: 'menus',
      menusLists: [],
      nodeLists: [],
      defaultChecked: [],
    };
  },

  created() {
    this.getList();
  },

  methods: {
    async getList() {
      try {
        this.loading = true;
        let res = await this.api.userAdmin.getPermission({ type: 1 });
        let res2 = await this.api.userAdmin.getPermission({ type: 2 });
        this.menusLists = res.data;
        this.nodeLists = res2.data;
        let lists = this.menusLists.concat(this.nodeLists);
        let lists_parent = lists.filter((item) => item.children.length > 0);
        let lists_should_cancel = lists_parent
          .filter((item) => {
            return item.children.some((child) => !this.row.permission_list.map((item) => item.id).includes(child.id));
          })
          .map((item) => item.id);
        this.row.permission_list = this.row.permission_list.filter((item) => !lists_should_cancel.includes(item.id));

        this.defaultChecked = this.row.permission_list.map((item) => item.id);
        this.loading = false;
      } catch (ex) {
        this.loading = false;
        console.error(ex);
      }
    },
    closeDialog() {
      this.$emit('update:isShowPower', false);
    },
    // 提交
    async doSubmit() {
      try {
        this.doSubmitLoading = true;
        let res = null;
        let permission_ids = this.$refs.menuTree.getCheckedKeys().concat(this.$refs.menuTree.getHalfCheckedKeys(), this.$refs.nodeTree.getCheckedKeys(), this.$refs.nodeTree.getHalfCheckedKeys());
        res = await this.api.userAdmin.permissionAssign({
          role_id: this.row.id,
          permission_ids,
        });
        this.$message.success(res.message);
        this.doSubmitLoading = false;
        this.closeDialog();
        this.$emit('success');
      } catch (ex) {
        console.error(ex);
        this.doSubmitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
